import React from 'react';

import { SearchBreadcrumb } from '../SearchBreadcrumb';
import { Flag, FlagModifier } from '../../atoms/Flag';
import { ContentAttachmentList } from '../ContentAttachmentList/ContentAttachmentList';
import { BADGE_STATUS, StatusBadge } from '../../../_lib/components/Badge';
import { PageLinkExtendedInfo } from '../../../_lib/components/PageLinkExtendedInfo';
import IUrl, { ISonURL } from '../../../types/IUrl';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { isNonEmptyArray } from '../../../lib/typeGuards';
import { LinkedTeaserImage } from '../LinkedTeaserImageInLists';
import { TextSnippet } from './TextSnippet';
import { MetaInfoContent } from '../../../_lib/components/MetaInfo';
import { IFileItemSearch } from '../../../types/api/FileItem';

type SearchResultTeaserProps = {
  teaserImage?: IUrl;
  // is this even used?
  searchListTemplate?: string;
  pageLink: ISonURL;
  teaserText?: string;
  breadcrumb?: ISonURL[];
  snippet?: string;
  attachments?: IFileItemSearch[];
  elevated?: boolean;
  hasReadRestrictions?: boolean;
  archived?: boolean;
  archiveDate?: string;
  documentTypes?: string[];
};

export function SearchResultTeaser({
  teaserText,
  teaserImage,
  documentTypes = [],
  pageLink,
  searchListTemplate,
  elevated,
  archiveDate,
  archived,
  hasReadRestrictions,
  breadcrumb,
  snippet,
  attachments = [],
}: SearchResultTeaserProps) {
  const { t } = useSonTranslation('SearchResultTeaser');

  return (
    <div className="search-result-teaser">
      {teaserImage && searchListTemplate === 'teaser' && (
        <div className="search-result-teaser__image">
          <LinkedTeaserImage pageLink={pageLink.url} imageSrc={teaserImage.url} />
        </div>
      )}
      <div className="search-result-teaser__content">
        <div className="search-result-teaser__head">
          <PageLinkExtendedInfo highlightText pageLink={pageLink} restricted={hasReadRestrictions} />
          {elevated && <Flag modifier={FlagModifier.MARGIN}>{t('elevated')}</Flag>}
          {archived && (
            <span className="search-result-teaser__head-item">
              <StatusBadge status={BADGE_STATUS.ARCHIVED} archiveDate={archiveDate} />
            </span>
          )}
        </div>
        {isNonEmptyArray(documentTypes) && <MetaInfoContent documentTypes={documentTypes} />}
        {teaserText && <TextSnippet text={teaserText} />}
        {breadcrumb && <SearchBreadcrumb breadcrumbs={breadcrumb} />}
        {snippet && <TextSnippet text={snippet} />}
        <ContentAttachmentList attachments={attachments} useTextMarker />
      </div>
    </div>
  );
}
